import storage from "./storage";

export default function useVisitorId() {
    let id = storage.getItem('visitor_id');
    if (id) return id;
    id = btoa(Math.random().toString());
    storage.setItem("visitor_id", id);
    return id;
}